import React, { Component } from 'react';
import { connect } from 'react-redux';
import ConsentPDFExport from '../admin/ConsentPDFExport';

class PrivacyConsent extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            clients: [],
            loading: true
        };
    }

    componentDidMount() {
        this.fetchClients();
        
        // Fallback timeout to stop loading if data doesn't arrive
        this.timeoutId = setTimeout(() => {
            if (this.state.loading) {
                console.log('PrivacyConsent - Timeout reached, stopping loading');
                this.setState({ loading: false, clients: [] });
            }
        }, 3000);
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    componentDidUpdate(prevProps) {
        // Update clients when applicants prop changes
        if (prevProps.applicants !== this.props.applicants) {
            this.fetchClients();
        }
    }

    fetchClients = async () => {
        try {
            console.log('PrivacyConsent - applicants prop:', this.props.applicants);
            
            // Get clients from the applicants prop
            if (this.props.applicants && Object.keys(this.props.applicants).length > 0) {
                const clientsArray = Object.keys(this.props.applicants).map(key => ({
                    id: key,
                    ...this.props.applicants[key]
                }));
                console.log('PrivacyConsent - clients array:', clientsArray);
                this.setState({ clients: clientsArray, loading: false });
            } else {
                // No applicants available, stop loading
                console.log('PrivacyConsent - No applicants found');
                this.setState({ clients: [], loading: false });
            }
        } catch (error) {
            console.error('Error fetching clients:', error);
            this.setState({ clients: [], loading: false });
        }
    };

    renderAvatar = () => {
        // Use filenames we know exist under public/metronic/assets/media/svg/avatars
        const males = [
            "001-boy.svg",
            "004-boy-1.svg",
            "007-boy-2.svg",
            "008-boy-3.svg",
            "009-boy-4.svg",
            "011-boy-5.svg",
            "015-boy-6.svg",
            "016-boy-7.svg",
            "024-boy-9.svg",
            "026-boy-10.svg",
        ];
        const females = [
            "002-girl.svg",
            "003-girl-1.svg",
            "005-girl-2.svg",
            "006-girl-3.svg",
            "007-girl-2.svg",
            "010-girl-4.svg",
            "012-girl-5.svg",
            "013-girl-6.svg",
            "014-girl-7.svg",
            "017-girl-8.svg",
            "018-girl-9.svg",
        ];

        return males[Math.floor(Math.random() * males.length)];
    };

    renderClients = () => {
        if (this.state.loading) {
            return (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }

        if (!this.state.clients || this.state.clients.length === 0) {
            return (
                <div className="text-center py-5 text-muted">
                    No clients found for this application.
                </div>
            );
        }

        return this.state.clients.map((client, index) => (
            <div key={client.id || index} className="mb-8">
                <div className="d-flex align-items-center mb-4">
                    <div className="symbol symbol-50 symbol-light mr-4">
                        <span className="symbol-label">
                            <img
                                src={process.env.PUBLIC_URL + `/metronic/assets/media/svg/avatars/${this.renderAvatar()}`}
                                className="h-75 align-self-end"
                                alt=""
                            />
                        </span>
                    </div>
                    <div>
                        <span className="text-dark-75 font-weight-bolder font-size-lg d-block">
                            {client.name || 'Unknown Client'}
                        </span>
                        <span className="text-muted font-weight-bold">
                            {client.email || 'No email provided'}
                            {client.mobile ? ` | ${client.mobile}` : ''}
                        </span>
                    </div>
                </div>

                {client.firebase_id ? (
                    <ConsentPDFExport
                        userId={client.firebase_id}
                        userName={client.name}
                    />
                ) : (
                    <div className="text-muted font-size-sm pl-2">
                        This client has not created an account yet.
                    </div>
                )}
            </div>
        ));
    };

    render() {
        return (
            <div className="card card-custom card-stretch gutter-b">
                <div className="card-header border-0 py-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">Privacy Consent Management</span>
                        <span className="text-muted mt-3 font-weight-bold font-size-sm">
                            Snapshots of each client's consent. Open any to view / save as PDF.
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <div className="d-flex align-items-center">
                            <i className="fas fa-shield-alt text-primary mr-2"></i>
                            <span className="text-muted font-size-sm">
                                3-month consent renewal required
                            </span>
                        </div>
                    </div>
                </div>

                <div className="card-body pt-2">
                    {this.renderClients()}
                </div>

                <div className="card-footer border-0 pt-0">
                    <div className="alert alert-custom alert-light-primary" role="alert">
                        <div className="alert-icon">
                            <i className="flaticon-information"></i>
                        </div>
                        <div className="alert-text">
                            <strong>Privacy Compliance:</strong> Every consent is versioned and never
                            deleted. Export PDF records include the full policy text, data-sharing disclosure,
                            the Equifax credit-check answer, timestamps, IP addresses, user agents, and expiry
                            dates. All consents expire after 3 months and require renewal.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    applicants: state.admin.active_application?.application?.applicants
});

export default connect(mapStateToProps)(PrivacyConsent); 